import { View } from '@components/primitives';
import BPSubProdNominals from '@molecules/BPSubProdNominals';
import BPSubProductTile from '@molecules/BPSubProductTile';
import React from 'react';
import styles from './styles';

// ---------- TYPES ----------
interface ProductConfig {
  productId: number;
  productName: string;
  noOfColumns?: number;
  hasPhoneChange?: boolean;
}

interface ListOfProdProps {
  subProducts: string[];
  productNominals: Record<string, { iconLink: string }[]>;
  selectedProductItem: string;
  setSelectedProductItem: (value: string) => void;
  productId: number;
  productConfig: ProductConfig;
  productApiData: Record<string, any>;
  source: string;
  isFavourite: boolean;
}

interface SubProdNominalsProps extends Omit<ListOfProdProps, 'subProducts' | 'setSelectedProductItem'> {}

// ---------- HELPERS ----------
export function shouldShowNominalsOnSelection(props: SubProdNominalsProps) {
  const { productNominals, selectedProductItem, productId, productConfig, productApiData, source, isFavourite } = props;

  if (selectedProductItem !== '') {
    return (
      <BPSubProdNominals
        productNominals={productNominals}
        selectedProductItem={selectedProductItem}
        productId={productId}
        productConfig={productConfig}
        productApiData={productApiData}
        source={source}
        isFavourite={isFavourite}
      />
    );
  }

  return null;
}

export function showListOfProducts(props: ListOfProdProps) {
  const {
    subProducts,
    productNominals,
    selectedProductItem,
    setSelectedProductItem,
    productId,
    productConfig,
    productApiData,
    source,
    isFavourite,
  } = props;

  return (
    <View>
      <View style={styles.subProductContainer}>
        {subProducts.map(productItem => {
          const productNominal = productNominals[productItem]?.[0];
          const iconLink = productNominal?.iconLink;

          if (iconLink) {
            return (
              <BPSubProductTile
                key={productItem}
                selectedProductItem={selectedProductItem}
                productItem={productItem}
                iconLink={iconLink}
                setSelectedProductItem={setSelectedProductItem}
                productId={productId}
                productConfig={productConfig}
                source={source}
                isFavourite={isFavourite}
              />
            );
          }
          return null;
        })}
      </View>
      {shouldShowNominalsOnSelection({
        productNominals,
        selectedProductItem,
        productId,
        productConfig,
        productApiData,
        source,
        isFavourite,
      })}
    </View>
  );
}
